<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>

    <div v-if="isAdmin && hasClients" class="form-group row">
      <label class="col-sm-2 col-form-label" for="client_id">Mandant:</label>
      <div class="col-sm-10">
        <select v-model="selectedClientId" class="form-control" name="client_id">
          <option v-for="client in clients" :key="client.id" :value="client.id">
            {{ client.name }}
          </option>
        </select>
      </div>
    </div>
    <div v-else-if="!isAdmin && clientObject" class="form-group row">
      <label class="col-sm-2 col-form-label" for="client_id">Mandant:</label>
      <div class="col-sm-10">
        <input :value="clientObject.id" name="client_id" type="hidden"/>
        <input :value="clientObject.name" class="form-control" disabled type="text"/>
      </div>
    </div>
    <div v-else class="form-group row">
      <label class="col-sm-2 col-form-label" for="client_id">Mandant:</label>
      <div class="col-sm-10">
        <input name="client_id" type="hidden" value="0"/>
        <input
            class="form-control"
            disabled
            type="text"
            value="keine Mandanten mit Punktesystemen gefunden."
        />
      </div>
    </div>

    <input :value="loyaltySettingId" name="loyalty_setting_id" type="hidden"/>

    <div class="hr-line-dashed"></div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label">
        Bezeichnung in der App:
        <span class="tooltip-container">
          <i class="fa fa-question-circle tooltip-icon"></i>
          <span class="tooltip-text">
            Diese Bezeichnung wird im Punkte- bzw. Statusverlauf in der App angezeigt
          </span>
        </span>
      </label>
      <div class="col-sm-10">
        <input
            v-model="localPromotion.name"
            class="form-control m-b"
            name="name"
            type="text"
        />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Typ:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.type"
            class="form-control m-b"
            name="type"
        >
          <option value="1">Zusatzpunkte</option>
          <option value="2">Vervielfachung</option>
        </select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>

    <div v-if="localPromotion.type === 2" class="form-group row">
      <label class="col-sm-2 col-form-label">Wert der Vervielfachung:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.multiplier"
            class="form-control m-b"
            name="multiplier"
        >
          <option v-for="n in 9" :key="n" :value="n + 1">
            {{ n + 1 }}-fach
          </option>
        </select>
      </div>
    </div>

    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Ausschüttung bei:</label>
      <div class="col-sm-10">
        <select
            v-model.number="localPromotion.activity"
            class="form-control m-b"
            name="activity"
        >
          <option value="1">App-Registrierung</option>
          <option value="2">App-Aktivierung</option>
          <option value="3">Selektion Warengruppe/Marke/Lieferant/Filiale</option>
        </select>
      </div>
    </div>
    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Anzahl Punkte:</label>
      <div class="col-sm-10">
        <input
            v-model.number="localPromotion.bonus_points"
            class="form-control m-b"
            min="0"
            name="bonus_points"
            type="number"
        />
      </div>
    </div>
    <div v-if="localPromotion.type === 1" class="form-group row">
      <label class="col-sm-2 col-form-label">Gültigkeit der Punkte (in Tagen):</label>
      <div class="col-sm-10">
        <input
            v-model.number="localPromotion.days_available"
            class="form-control m-b"
            min="0"
            name="days_available"
            type="number"
        />
      </div>
    </div>

    <div v-if="showRestrictions">
      <div class="hr-line-dashed"></div>
      <h3>
        Punkteaktion einschränken
        <span class="tooltip-container">
          <i class="fa fa-question-circle tooltip-icon"></i>
          <span class="tooltip-text">
            Zusatzpunkte oder Punktevervielfachungen können auf definierte Warengruppen und/oder Marken und/oder Lieferanten und/oder Filialen eingeschränkt werden. Es besteht die Möglichkeit, eine beliebige Anzahl an Bedingungen hinzuzufügen. Voraussetzung ist die Datenpflege im Warenwirtschaftssystem. Wird keine Einschränkung hinterlegt, gilt die Aktion für alle Einkäufe.
          </span>
        </span>
      </h3>
      <p v-if="loadingRestrictionOptions" class="text-muted">
        <i class="fa fa-spinner fa-spin"></i> Auswahlwerte werden geladen …
      </p>
      <loyalty-promotion-restriction-table
          v-for="restriction in restrictionTables"
          :key="restriction.field"
          v-model="localPromotion[restriction.field]"
          :column="restriction.column"
          :name="restriction.field"
          :options="restrictionOptions[restriction.optionsKey] || []"
          :title="restriction.title"
      ></loyalty-promotion-restriction-table>
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i>
        <template v-if="restrictionSummary.length === 0">Gilt für alle Einkäufe.</template>
        <template v-else>
          <span>Gilt für Artikel mit <template v-for="(part, index) in restrictionSummary"><strong v-if="index > 0">UND </strong>{{ part }} </template></span>
        </template>
      </div>
      <div class="hr-line-dashed"></div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 col-md-2 col-form-label">Verwendung der Punkte:</label>
      <div class="col-sm-9 col-md-10">
        <label class="usage-checkbox">
          <input v-model="localPromotion.counts_for_points" name="counts_for_points" type="checkbox" value="1"/>
          Einlösbare Bonuspunkte
        </label>
        <label class="usage-checkbox">
          <input v-model="localPromotion.counts_for_status" name="counts_for_status" type="checkbox" value="1"/>
          Statusberechnung
        </label>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 col-md-2 col-form-label">Startzeitpunkt:</label>
      <div class="col-sm-9 col-md-10">
        <input
            v-model="localPromotion.start_at"
            class="form-control"
            name="start_at"
            type="datetime-local"
        />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-md-2 col-form-label">Endzeitpunkt:</label>
      <div class="col-sm-9 col-md-10">
        <input
            v-model="localPromotion.end_at"
            class="form-control"
            name="end_at"
            type="datetime-local"
        />
      </div>
    </div>

    <div v-if="currentLoyaltyLevels.length > 0 && localPromotion.type !== 1" class="form-group row">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-10">
        <input
            :value="limitToSpecialLevels ? 1 : 0"
            name="limit_to_special_levels"
            type="hidden"
        />
        <div class="form-check m-b-sm">
          <input
              id="limit-special-levels"
              v-model="limitToSpecialLevels"
              class="form-check-input"
              type="checkbox"
          />
          <label class="form-check-label" for="limit-special-levels">
            Vervielfachung auf bestimmte Statusgruppen beschränken
            <span class="tooltip-container">
              <i class="fa fa-question-circle tooltip-icon"></i>
              <span class="tooltip-text">
                Bei Aktivierung dieser Funktion beschränkt sich die Vervielfachung nur auf die Kunden, die im Aktionszeitraum die gewählten Statusgruppen erreicht haben.
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>

    <div
        v-if="currentLoyaltyLevels.length > 0 && localPromotion.type !== 1 && limitToSpecialLevels"
        class="form-group row"
    >
      <label class="col-sm-2 col-form-label">Statusgruppen:</label>
      <div class="col-sm-10">
        <div v-for="level in currentLoyaltyLevels" :key="level.id">
          <input
              :id="'status-' + level.id"
              v-model="localPromotion.loyalty_level_ids"
              :disabled="forceAllStatuses"
              :name="forceAllStatuses ? null : 'loyalty_level_ids[]'"
              :value="Number(level.id)"
              type="checkbox"
          />
          <label :for="'status-' + level.id">{{ level.name }}</label>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";
import LoyaltyPromotionRestrictionTable from "./LoyaltyPromotionRestrictionTable.vue";

// Mirror App\Config\Loyalty\LoyaltyPromotionTypeConfig / LoyaltyPromotionActivityConfig.
const PROMOTION_TYPE = {
  BONUS_POINTS: 1,
  MULTIPLIER: 2,
};

const PROMOTION_ACTIVITY = {
  APP_REGISTRATION: 1,
  APP_ACTIVATION: 2,
  PRODUCT_SELECTION: 3,
};

const RESTRICTION_TABLES = [
  {field: "restricted_product_groups", optionsKey: "product_groups", title: "Einschränkung auf Warengruppen", column: "Warengruppe"},
  {field: "restricted_labels", optionsKey: "labels", title: "Einschränkung auf Marken", column: "Marke"},
  {field: "restricted_suppliers", optionsKey: "suppliers", title: "Einschränkung auf Lieferanten", column: "Lieferant"},
  {field: "restricted_stores", optionsKey: "stores", title: "Einschränkung auf Filialen", column: "Filiale"},
];

export default {
  components: {VueToastr, LoyaltyPromotionRestrictionTable},
  props: {
    loyaltyLevels: {
      type: Array,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    clients: {
      type: [Array, Object],
      default: () => null
    },
    promotion: {
      type: Object,
      default: null
    },
    oldInput: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localPromotion: {
        name: "",
        type: 1,
        multiplier: 2,
        bonus_points: 0,
        activity: 1,
        start_at: "",
        end_at: "",
        loyalty_level_ids: [],
        days_available: 0,
        counts_for_points: false,
        counts_for_status: false,
        restricted_product_groups: [],
        restricted_labels: [],
        restricted_suppliers: [],
        restricted_stores: [],
      },
      restrictionTables: RESTRICTION_TABLES,
      restrictionOptions: {},
      loadingRestrictionOptions: false,
      selectedClientId: null,
      disableLoyaltyLevels: false,
      originalClientId: null,
      isLoadingFromOldInput: false,
      limitToSpecialLevels: false,
    };
  },
  computed: {
    hasClients() {
      return Array.isArray(this.clients) && this.clients.length > 0;
    },
    clientObject() {
      return !Array.isArray(this.clients) ? this.clients : null;
    },
    loyaltySettingId() {
      if (this.selectedClientId && Array.isArray(this.clients)) {
        const selectedClient = this.clients.find(
            (client) => client.id === this.selectedClientId
        );
        return selectedClient ? selectedClient.loyalty_setting_id : null;
      }
      if (this.clientObject) {
        return this.clientObject.loyalty_setting_id;
      }
      return null;
    },
    currentLoyaltyLevels() {
      if (this.isAdmin && Array.isArray(this.clients)) {
        if (!this.selectedClientId) {
          return [];
        }
        const selectedClient = this.clients.find(
            (client) => client.id === this.selectedClientId
        );
        return selectedClient && selectedClient.loyalty_levels
            ? selectedClient.loyalty_levels
            : [];
      }
      if (!this.isAdmin && this.clientObject && this.clientObject.loyalty_levels) {
        return this.clientObject.loyalty_levels;
      }
      return [];
    },
    currentClientId() {
      if (this.selectedClientId) {
        return this.selectedClientId;
      }
      return this.clientObject ? this.clientObject.id : null;
    },
    showRestrictions() {
      return this.localPromotion.type === PROMOTION_TYPE.MULTIPLIER
          || (this.localPromotion.type === PROMOTION_TYPE.BONUS_POINTS
              && this.localPromotion.activity === PROMOTION_ACTIVITY.PRODUCT_SELECTION);
    },
    // OR within one table, AND between tables; empty tables are ignored.
    restrictionSummary() {
      return this.restrictionTables
          .filter(restriction => this.localPromotion[restriction.field].length > 0)
          .map(restriction => `${restriction.column} ${this.localPromotion[restriction.field].join(" oder ")}`);
    },
    forceAllStatuses() {
      return (
          this.localPromotion.type === 1 &&
          (this.localPromotion.activity === 1 || this.localPromotion.activity === 2)
      );
    },
  },
  watch: {
    "localPromotion.type"(newType) {
      if (this.isLoadingFromOldInput) {
        return;
      }
      if (newType === 2) {
        this.localPromotion.bonus_points = 0;
        this.localPromotion.days_available = 0;
        if (!this.localPromotion.multiplier) {
          this.localPromotion.multiplier = 2;
        }
        if (this.currentLoyaltyLevels.length > 0) {
          this.localPromotion.loyalty_level_ids = [];
        }
      } else if (newType === 1) {
        this.localPromotion.multiplier = 2;
        this.$nextTick(() => {
          this.applyForceAllStatusesLogic();
        });
      }
    },
    selectedClientId(newId, oldId) {
      if (this.originalClientId !== null && newId === this.originalClientId) {
        return;
      }
      if (this.isLoadingFromOldInput) {
        return;
      }
      this.localPromotion.loyalty_level_ids = [];
      this.limitToSpecialLevels = false;
      // Values of another client are meaningless; the initial assignment (oldId null) keeps loaded values.
      if (oldId !== null) {
        this.resetRestrictions();
      }
      this.$nextTick(() => {
        this.applyForceAllStatusesLogic();
      });
    },
    "localPromotion.activity"(newActivity) {
      this.applyForceAllStatusesLogic();
    },
    currentClientId: {
      immediate: true,
      handler(clientId) {
        this.fetchRestrictionOptions(clientId);
      }
    },
    limitToSpecialLevels(newValue) {
      if (!newValue) {
        this.localPromotion.loyalty_level_ids = [];
      }
    },
  },
  methods: {
    async fetchRestrictionOptions(clientId) {
      this.restrictionOptions = {};
      if (!clientId) {
        return;
      }
      this.loadingRestrictionOptions = true;
      try {
        const response = await axios.get(`/backend/loyalty-program/promotions/restriction-options/${clientId}`);
        this.restrictionOptions = response.data;
      } catch (error) {
        this.$refs.toast.e("Auswahlwerte für die Einschränkungen konnten nicht geladen werden.", "Fehler");
      } finally {
        this.loadingRestrictionOptions = false;
      }
    },
    resetRestrictions() {
      this.restrictionTables.forEach(restriction => {
        this.localPromotion[restriction.field] = [];
      });
    },
    loadRestrictionsFromOldInput() {
      this.restrictionTables.forEach(restriction => {
        const values = this.oldInput[restriction.field];
        this.localPromotion[restriction.field] = Array.isArray(values) ? values : [];
      });
    },
    formatDateTimeForInput(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    applyForceAllStatusesLogic() {
      if (this.forceAllStatuses && this.currentLoyaltyLevels.length > 0) {
        this.localPromotion.loyalty_level_ids = this.currentLoyaltyLevels.map((lvl) => Number(lvl.id));
      } else if (!this.isLoadingFromOldInput && !this.forceAllStatuses) {
        // No longer need to reset if disableLoyaltyLevels is true, just ensure no 0 is left.
        this.localPromotion.loyalty_level_ids = this.localPromotion.loyalty_level_ids.filter(id => id !== 0);
      }
    },
    initializeLimitToSpecialLevels() {
      if (this.currentLoyaltyLevels.length === 0) {
        this.limitToSpecialLevels = false;
        return;
      }
      const selectedIds = Array.isArray(this.localPromotion.loyalty_level_ids)
          ? this.localPromotion.loyalty_level_ids
          : [];
      if (selectedIds.length === 0) {
        this.limitToSpecialLevels = false;
        return;
      }
      if (this.isAllLevelsSelected(selectedIds, this.currentLoyaltyLevels)) {
        this.limitToSpecialLevels = false;
        this.localPromotion.loyalty_level_ids = [];
        return;
      }
      this.limitToSpecialLevels = true;
    },
    loadFromOldInput() {
      this.isLoadingFromOldInput = true;
      if (this.oldInput.client_id) {
        this.selectedClientId = Number(this.oldInput.client_id);
      }
      if (this.oldInput.name) {
        this.localPromotion.name = this.oldInput.name;
      }
      if (this.oldInput.type !== undefined) {
        this.localPromotion.type = Number(this.oldInput.type);
      }
      if (this.oldInput.multiplier !== undefined) {
        this.localPromotion.multiplier = Number(this.oldInput.multiplier);
      }
      if (this.oldInput.bonus_points !== undefined) {
        this.localPromotion.bonus_points = Number(this.oldInput.bonus_points);
      }
      if (this.oldInput.activity !== undefined) {
        this.localPromotion.activity = Number(this.oldInput.activity);
      }
      if (this.oldInput.days_available !== undefined && this.oldInput.days_available !== null) {
        this.localPromotion.days_available = Number(this.oldInput.days_available);
      }
      this.localPromotion.counts_for_points = Boolean(this.oldInput.counts_for_points);
      this.localPromotion.counts_for_status = Boolean(this.oldInput.counts_for_status);
      if (this.oldInput.start_at) {
        this.localPromotion.start_at = this.oldInput.start_at;
      }
      if (this.oldInput.end_at) {
        this.localPromotion.end_at = this.oldInput.end_at;
      }
      if (this.oldInput.loyalty_level_ids) {
        this.localPromotion.loyalty_level_ids = Array.isArray(this.oldInput.loyalty_level_ids)
            ? this.oldInput.loyalty_level_ids.map(id => Number(id)).filter(id => id !== 0)
            : [];
      }
      this.loadRestrictionsFromOldInput();
      this.isLoadingFromOldInput = false;
      this.$nextTick(() => {
        this.initializeLimitToSpecialLevels();
      });
    },
    isAllLevelsSelected(promotionLevelIds, allLevels) {
      if (promotionLevelIds.length !== allLevels.length) {
        return false;
      }
      const promotionSet = new Set(promotionLevelIds.map(String));
      const allLevelsSet = new Set(allLevels.map(String));
      return promotionSet.size === allLevelsSet.size && [...promotionSet].every(val => allLevelsSet.has(val));
    }
  },
  mounted() {
    this.isLoadingFromOldInput = false;
    const hasOldInput = this.oldInput && Object.keys(this.oldInput).length > 0;

    if (hasOldInput) {
      this.loadFromOldInput();
    } else if (this.promotion) {
      this.localPromotion = {...this.localPromotion, ...this.promotion};
      this.localPromotion.start_at = this.formatDateTimeForInput(this.promotion.start_at);
      this.localPromotion.end_at = this.formatDateTimeForInput(this.promotion.end_at);
      if (this.promotion.days_available !== undefined && this.promotion.days_available !== null) {
        this.localPromotion.days_available = Number(this.promotion.days_available);
      } else {
        this.localPromotion.days_available = 0;
      }
      if (this.promotion.client_id) {
        this.selectedClientId = this.promotion.client_id;
        this.originalClientId = this.promotion.client_id;
      }
      if (Array.isArray(this.promotion.loyalty_level_ids)) {
        this.localPromotion.loyalty_level_ids = this.promotion.loyalty_level_ids.map(
            (id) => Number(id)
        ).filter(id => id !== 0);
      } else {
        this.localPromotion.loyalty_level_ids = [];
      }

      this.isLoadingFromOldInput = true;
      this.$nextTick(() => {
        this.isLoadingFromOldInput = false;
        this.applyForceAllStatusesLogic();
        this.initializeLimitToSpecialLevels();
      });

    } else if (this.isAdmin && this.hasClients) {
      this.selectedClientId = this.clients[0].id;
      this.$nextTick(() => {
        this.applyForceAllStatusesLogic();
        this.initializeLimitToSpecialLevels();
      });
    }
  }
};
</script>

<style scoped>
.usage-checkbox {
  display: inline-flex;
  align-items: center;
  margin: 0 20px 0 0;
  font-weight: normal;
}

.usage-checkbox input {
  margin: 0 6px 0 0;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  margin-left: 6px;
}

.tooltip-icon {
  cursor: pointer;
  color: #007bff;
}

.tooltip-text {
  position: absolute;
  top: 50%;
  left: 110%;
  transform: translateY(-50%);
  visibility: hidden;
  opacity: 0;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12px;
  transition: opacity 0.1s ease-in-out;
  width: 220px;
  white-space: normal;
  z-index: 10;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #333 transparent transparent;
}
</style>
